import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { scrollTo } from "@/components/Nav";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import LivePuri from "@/components/LivePuri";
import WishlistDock from "@/components/WishlistDock";
import ReferralBanner from "@/components/ReferralBanner";
import Hotels from "@/components/Hotels";
import Team from "@/components/Team";
import TourSections from "@/components/TourSections";
import Rentals from "@/components/Rentals";
import Founder from "@/components/Founder";
import CarRates from "@/components/CarRates";
import Places from "@/components/Places";
import Itineraries from "@/components/Itineraries";
import PackageBuilder from "@/components/PackageBuilder";
import Reviews from "@/components/Reviews";
import Manifesto from "@/components/Manifesto";
import EnquiryForm from "@/components/EnquiryForm";
import Footer from "@/components/Footer";
import WhatsAppDock from "@/components/WhatsAppDock";
import AiPlanner from "@/components/AiPlanner";

export default function Home() {
  const [aiOpen, setAiOpen] = useState(false);
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) setTimeout(() => scrollTo(hash), 600);
  }, [hash]);
  return (
    <main data-testid="home-page">
      <Nav />
      <Hero onOpenAi={() => setAiOpen(true)} />
      <Marquee />
      <LivePuri />
      <TourSections />
      <Places />
      <Itineraries />
      <Rentals />
      <Founder />
      <CarRates />
      <PackageBuilder />
      <Hotels />
      <Reviews />
      <Team />
      <Manifesto />
      <EnquiryForm />
      <Footer />
      <WhatsAppDock />
      <WishlistDock />
      <ReferralBanner />
      <AiPlanner open={aiOpen} setOpen={setAiOpen} />
    </main>
  );
}
